/**
 * @group Constants
 * @summary
 * <blockquote>Constants for learning task section type values</blockquote>
 * 
 * @example
 * ```typescript
 * import { LEARNING_TASK_SECTION_TYPES } from '@shared/constants';
 * 
 * if (section.type === LEARNING_TASK_SECTION_TYPES.OVERVIEW) {
 *   // Handle overview section
 * }
 * ```
 */
export const LEARNING_TASK_SECTION_TYPES = {
  OVERVIEW: 'overview',
  INSTRUCTIONS: 'instructions',
  EXAMPLE: 'example',
  VERIFICATION: 'verification'
} as const; 